const CancelUploadError = require('./CancelUploadError');

/**
 * Class for cancelling upload processes.
 */
class CancellationToken {

    constructor (operationName = 'unknown') {
        this.operationName = operationName;
    }

    getOperationName () {
      return this.operationName;
    }

    throwIfCanceled() {
        if (this.isCanceled === true) {
            throw new CancelUploadError(`The ${this.operationName} operation was cancelled.`);
        }

    }

    cancel() {
        this.isCanceled = true;
    }
}

module.exports = CancellationToken;
